import React, { useEffect } from "react";
import Pregnancyscanscon from "./Pregnancyscanscon";
import Infiry from "../../About/Infiry";
import Callin from "../../About/Callin";
import Servicebanner from "../../Services/Servicebanner";
import NumberInfo from "../../Home/NumberInfo";
import Doctorbox from "../../Home/Docterbox";
import Divser from "../../About/Divser";
import Divider from "../../Divider";
import ServiceReview from "../../Services/ServiceReview";
import { movetop } from "../../../fun";
import { Helmet } from "react-helmet-async";

function Pregnancyscans() {
  type elem = {
    oneBody?: JSX.Element;
    twoBody?: JSX.Element;
    threeBody?: JSX.Element;
  };
  const elemnt: elem = {
    oneBody: <Pregnancyscanscon />,
    twoBody: <Infiry />,
    threeBody: <Callin />,
  };

  useEffect(() => {
    movetop();
  }, []);
  return (
    <>
      <Helmet>
        <title>Pregnancy Scan in Whitefield</title>
        <meta
          name="description"
          content="Looking for the best Pregnancy Scan in Whitefield or Vijayanagar? Then you are in the right place. Feel free to contact us."
        />
        <meta
          name="keywords"
          content="Best Pregnancy Scan in Whitefield, Best Pregnancy Scan in Vijayanagar, healthcare services in Whitefield, healthcare services in Vijayanagar, Multispeciality Clinic in Vijayanagar"
        />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalBusiness",
            "@id":
              "https://www.elvhealthcare.com/bestpregnancyscansinwhitefield#organization",
            name: "ELV Health Care Polyclinics",
            url: "https://www.elvhealthcare.com/bestpregnancyscansinwhitefield",
            description:
              "ELV Health Care Polyclinics in Whitefield provides pregnancy scan services including early pregnancy confirmation scans, NT scan, anomaly scan, growth monitoring and Doppler scans for accurate fetal assessment and prenatal care support.",
            logo: "https://www.elvhealthcare.com/favicon.ico",
            telephone: ["+91-9535264855", "+91-9535264854"],
            email: "elvhealthcare@gmail.com",
            address: {
              "@type": "PostalAddress",
              streetAddress: "MR ASTER, Ground Floor, Vijayanagar, Whitefield",
              addressLocality: "Bengaluru",
              addressRegion: "Karnataka",
              postalCode: "560066",
              addressCountry: "IN",
            },
            geo: {
              "@type": "GeoCoordinates",
              latitude: 12.9764418,
              longitude: 77.7583566,
            },
            hasMap: "https://maps.app.goo.gl/C1xXW4kQyTxR8Sug9",
            knowsAbout: [
              "Pregnancy ultrasound scans",
              "Early pregnancy confirmation scan",
              "Dating scan and viability assessment",
              "NT scan (Nuchal Translucency)",
              "Anomaly scan (Level II)",
              "Growth scan and fetal well-being monitoring",
              "Doppler scan for placental and fetal circulation",
            ],
            keywords: [
              "best pregnancy scans in Immadihalli",
              "best pregnancy scans in Whitefield",
              "best pregnancy scans in Bangalore",
              "best pregnancy scans in Kundalahalli",
              "best pregnancy scans in Pattandur Agrahara",
            ],
          })}
        </script>
      </Helmet>
      <h2 style={{ display: "none" }}>
        Pregnancy Scan in Whitefield contributing to a healthy and
        well-monitored pregnancy journey. Contact us for the best Pregnancy Scan
        in Whitefield.
      </h2>

      <Servicebanner name="Pregnancy scans" banner={"../photo/dd20.jpg"} />
      <NumberInfo test="test-black" />
      <Doctorbox />
      <Divser elemnt={elemnt} />
      {/* <div className="pt-6">
                <Divider />
              </div>
              <Doctorbox /> */}
      <div className="pt-10 pb-4">
        <Divider />
      </div>
      <ServiceReview />
    </>
  );
}

export default Pregnancyscans;
